import { Component } from '@angular/core';
import {
  Checkout,
  Membership,
  Overview,
  Purchase
} from '@com-delta-idp/mnx-sky-club-ui';
import { StateFacade } from '../../data-access/facades/state.facade';
import { PURCHASE_CART_URL } from '../../data-access/models';
import { DataLayerAnalyticsService } from '../../data-access/services/analytics/data-layer.service';

@Component({
  selector: 'idp-sky-club',
  templateUrl: './sky-club.component.html',
  styleUrls: ['./sky-club.component.scss']
})
export class SkyClubComponent {
  emptyOverview: Overview = {} as Overview;
  emptyPurchase: Purchase = {} as Purchase;
  emptyCheckout: Checkout = {} as Checkout;

  constructor(public skyClub: StateFacade,
    public dataLayer: DataLayerAnalyticsService
  ) {
    this.dataLayer.pageLoadStart = Date.now();
    skyClub.init();
  }

  redirect(url: string, type: string) {
    window.open(url, type === 'link' ? '_blank' : '_self');
  }

  addToCart(membership: Membership) {
    this.skyClub.addToCart(membership);
  }

  checkOut() {
    location.href = PURCHASE_CART_URL;
  }

  previousButton() {
    location.reload();
  }
}
